import { Component, Input, type OnInit } from '@angular/core';

import { focusChangeOptionsToConfig } from '../../helpers/tracker-options-to-config';
import { RfaFormControl, RfaValidators } from '../../../level1';
import type { RfaComponents } from '../RfaComponents';

@Component({
  selector: 'rfa-text-area',
  templateUrl: './rfa-text-area.component.html',
  styleUrls: ['./rfa-text-area.component.scss'],
})
export class RfaTextAreaComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) control!: RfaFormControl<
    (typeof RfaComponents.TextArea)['valueType'],
    typeof RfaComponents.TextArea
  >;

  autocompleteId!: string;

  ngOnInit(): void {
    this.autocompleteId =
      this.control.options.autocompleteId ??
      this.control.generateRandomAutocompleteId();
  }

  get showOptional(): boolean {
    return !this.control.hasValidator(RfaValidators.required);
  }

  focusChangeTrackConfig() {
    return focusChangeOptionsToConfig(
      this.control.options.analytics?.focusChangeTracker ?? {
        fieldName: this.control.options.label,
      },
      {
        fieldName: this.control.options.label,
        hashValue: false,
      }
    );
  }

  get charactersLeft(): number {
    return this.control.options.maxLength - this.control.value.length;
  }

  get charactersLeftText(): string {
    return `Je hebt ${this.charactersLeft} teken(s) over`;
  }

  get tooManyCharactersText(): string {
    return `Je hebt ${this.charactersLeft * -1} teken(s) te veel`;
  }
}
